<template>
  <div>
    <div class="alert alert-danger">
      The number of revisions for this permit exceeds the allowed amount. You must
      <router-link :to="{name: 'PermitApplication', params: {projectType: projectType}}">
        submit a new permit application.
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevisionInvalid',
  props: ['projectType'],
  mounted() {
    this.$store.commit('temporaryForm', null);
  },
};
</script>
